import { AlertCircle, CheckCircle2 } from "lucide-react";

/**
 * Cartel de resultado de un guardado, en verde o en rojo.
 *
 * Vive a nivel de `MarcaPage` y no adentro de los paneles a propósito: al
 * guardar bien se dispara `atlas:brand-changed`, y eso hace que
 * `useBrandProfile` recargue las marcas → `loadingBrands` pasa por `true` →
 * la pantalla vuelve al spinner un instante y DESMONTA el panel. Un mensaje
 * de éxito que viviera adentro del panel se borraría justo cuando hay que
 * mostrarlo. Arriba sobrevive a esa recarga (que además es deseable: los datos
 * se releen de la base, así que lo que queda en pantalla es lo persistido).
 */

export interface MensajeGuardado {
  tipo: "ok" | "error";
  texto: string;
}

export const BannerGuardado = ({ mensaje }: { mensaje: MensajeGuardado | null }) => {
  if (!mensaje) return null;
  const ok = mensaje.tipo === "ok";
  return (
    <div
      role="status"
      className={`mt-4 flex items-start gap-2 rounded-xl border py-2.5 px-4 text-[13px] ${
        ok
          ? "border-[#CDEBD8] bg-[#F2FBF5] text-[#1F7A45]"
          : "border-[#F8E3E2] bg-[#FCF3F2] text-[#C33B36]"
      }`}
    >
      {ok ? (
        <CheckCircle2 className="mt-px h-4 w-4 shrink-0" />
      ) : (
        <AlertCircle className="mt-px h-4 w-4 shrink-0" />
      )}
      <span className="font-medium">{mensaje.texto}</span>
    </div>
  );
};

export default BannerGuardado;
